import { AddLeaderboardForm } from '@/modules/leaderboard/add-leaderboard';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/leaderboard/add')({
  component: AddLeaderboardPage,
});

function AddLeaderboardPage() {
  return <AddLeaderboardForm />;
}
